import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'playButtonText',
  pure: false,
})
export class PlayButtonTextPipe implements PipeTransform {
  private readonly asyncPipe: AsyncPipe;
  constructor(private readonly translateService: TranslateService, private readonly cdr: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(this.cdr);
  }

  public transform(type: string, inProgress: boolean, seasonNumber?: number, episodeNumber?: number): string {
    const text = this.getText(type, inProgress);

    if (!text) {
      return;
    }
    if (seasonNumber !== undefined && seasonNumber !== null && episodeNumber !== undefined && episodeNumber !== null) {
      return this.asyncPipe.transform(this.translateService.get(text, { season: seasonNumber, episode: episodeNumber }));
    } else if (type === 'series') {
      return this.asyncPipe.transform(this.translateService.get(text, { season: 1, episode: 1 }));
    }
    return this.asyncPipe.transform(this.translateService.get(text));
  }

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  private getText(type: string, inProgress: boolean): string {
    switch (type) {
      case 'movie':
        return inProgress ? 'Heroban_SD_Resume_Btn' : 'SD_Episode_Btn';
      case 'episode':
        return inProgress ? 'Heroban_SD_Resume_Btn_Series_Episode' : 'Heroban_SD_PlaySE_Btn';
      case 'season':
        return inProgress ? 'Heroban_SD_Resume_Btn_Series_Episode' : 'Player_NxtEpisode_Btn';
      case 'series':
        return inProgress ? 'Heroban_SD_Resume_Btn_Series_Episode' : 'Heroban_SD_PlaySE_Btn';
    }
  }
}
